module.exports = __webpack_public_path__ + "img/secret_santa_enroll.2130cba8.png";